import { pgTable, uuid, text, timestamp, unique, index } from "drizzle-orm/pg-core";

export const translationOverrides = pgTable(
  "translation_overrides",
  {
    id: uuid("id").primaryKey().defaultRandom(),
    scope: text("scope").notNull().$type<"storefront" | "admin">(),
    key: text("key").notNull(),
    locale: text("locale").notNull().$type<"lv" | "en" | "ru">(),
    value: text("value").notNull(),
    createdAt: timestamp("created_at", { withTimezone: true }).notNull().defaultNow(),
    updatedAt: timestamp("updated_at", { withTimezone: true }).notNull().defaultNow(),
  },
  (t) => ({
    scopeKeyLocaleUniq: unique("translation_overrides_scope_key_locale_uniq").on(
      t.scope,
      t.key,
      t.locale,
    ),
    scopeLocaleIdx: index("translation_overrides_scope_locale_idx").on(t.scope, t.locale),
  }),
);

export type TranslationOverride = typeof translationOverrides.$inferSelect;
export type NewTranslationOverride = typeof translationOverrides.$inferInsert;
